import { NgOptimizedImage, DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ModalService } from '../../modal/modal.service';
import { NotificationService } from '../../notification/notification.service';
import { SupportService } from '../../support.service';
import { ToggleUserActionsDirective } from '@shared/directives/toggle-user-actions.directive';
import { IconComponent } from '@shared/icon/icon.component';
import { ModalBoxComponent } from '@shared/modal-box/modal-box.component';
import { ChatEmotePipe } from '@shared/pipes/chat-emote.pipe';
import { NamePipe } from '@shared/pipes/name.pipe';
import { SessionService } from '@shared/session.service';

@Component({
  selector: 'app-support-ticket-view-modal',
  templateUrl: './support-ticket-view-modal.component.html',
  styleUrls: ['./support-ticket-view-modal.component.scss'],
  imports: [ModalBoxComponent, NgOptimizedImage, ToggleUserActionsDirective, IconComponent, FormsModule, DatePipe, ChatEmotePipe, NamePipe],
})
export class SupportTicketViewModalComponent implements OnInit {
  message: string;

  constructor(private modalService: ModalService, public supportService: SupportService, public session: SessionService, private notificationService: NotificationService) {
    this.modalService.maxWidth = 956;
  }

  async ngOnInit(): Promise<void> {
    await this.supportService.getTicket(this.modalService.data);
  }

  async closeTicket() {
    await this.supportService.closeTicket();
    await this.supportService.getTicket(this.supportService.currentTicket.id);

    await this.supportService.getTickets();
  }

  isTicketClosedByCurrentUser(): boolean {
    const currentUserId = this.session.profile()?.steamid;

    const closedByUserId = this.supportService.currentTicket.response_userid;

    return currentUserId === closedByUserId;
  }

  async sendMessage() {
    await this.supportService.respondToTicket(this.message);
    await this.supportService.getTicket(this.supportService.currentTicket.id);
    this.message = '';
  }

  async copySteamid(steamid: string) {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = steamid;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);

    this.showSuccess();
  }

  showSuccess() {
    this.notificationService.success('Steam ID copied to clipboard!', 'Copied!');
  }

  getRoleClass(role: number): string {
    switch (role) {
      case 3:
        return 'admin';
      default:
        return '';
    }
  }

  getRoleTag(role: number): string {
    switch (role) {
      case 3:
        return 'Admin';
      default:
        return '';
    }
  }
}
